<ion-header>
  <cc-header [info]="header" (iconClicked)="close()" (secondIconClicked)="reset()">
  </cc-header>
</ion-header>

<ion-content>
  <cc-stepper [activeStep]="activeStep" (stepperClicked)="stepperClicked($event)"></cc-stepper>

  <div class="steps-container">
    <div *ngIf="failure" class="ion-text-center ion-padding-start ion-padding-end">
      <ion-text color="primary">
        <h5>{{ failure }}</h5>
      </ion-text>
    </div>

    <swiper-container #swiper initial-slide="0" class="swiper-no-swiping"
      (swiperslidechange)="slideChange()">
      <swiper-slide>
        <cc-enclosure-list *ngIf="company" [company]="company" (selected)="selectEnclosure($event)"></cc-enclosure-list>
      </swiper-slide>
      <swiper-slide>
        <cc-item-spot-list *ngIf="selectedEnclosureId" [company]="company" [activeStep]="activeStep"
          [enclosureId]="selectedEnclosureId" (selected)="selectItemSpot($event)">
        </cc-item-spot-list>
      </swiper-slide>
      <swiper-slide>
        <cc-failures-detail-list *ngIf="selectedItemId" #failureDetails [company]="company" (selected)="add($event)"
        [enclosureId]="selectedEnclosureId" [itemSpot]="selectedItemSpot">
        </cc-failures-detail-list>
      </swiper-slide>
    </swiper-container>
  </div>

</ion-content>

<ion-footer *ngIf="activeStep === 2">
  <ion-toolbar>
    <ion-button (click)="addFailures()" class="ion-no-margin footer-button" expand="block" color="primary">
      {{ 'add-failure-modal.Agregar fallas'  | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
